<template>
    <div class="lms-progress">
        <div class="lms-progress-con" :style="{width:width+'%'}">
            <span v-if="width>=95" class="lms-progress-text" style="color:#fff;float:right;margin-right:5px">{{width}}%</span>
        </div>
        <span v-if="width<95" class="lms-progress-text">{{width}}%</span>
    </div>
</template>

<script>
export default {
    props:{
        width: {
            type: [String, Number],
            default: 0
        },
        
    },
}
</script>

<style lang="less">
    .lms-progress{
        width: 100%;
        border:1px solid rgba(77,142,246,1);
        border-radius:2px;
        height:22px;
        padding: 1px;
        display: flex;
        color: #4D8EF6;
        background:rgba(77,142,246,0.15);
        box-sizing: border-box;
        &-con{
            height: 100%;
            background:rgba(77,142,246,1);
            transition: width .6s ease;
        }
        &-text{
            margin-left: 8px;
            font-size:12px;
            display: flex;
            align-items: center;
        }
    }
</style>
